<script setup>
import { defineEmits, defineProps } from 'vue';

const props = defineProps({
  modelValue: Boolean,
});

const emit = defineEmits(['update:modelValue']);

const toggle = () => {
  emit('update:modelValue', !props.modelValue);
};
</script>

<template>
  <label class="toggle-switch" @click.stop>
    <input type="checkbox" :checked="modelValue" @change="toggle" />
    <span class="slider round"></span>
  </label>
</template>

<style scoped lang="scss">
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 2.5rem;
  height: 1.5rem;
  flex-shrink: 0;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $gray50;
  border-radius: 1rem;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  width: 1.125rem;
  height: 1.125rem;
  left: 3px;
  bottom: 3px;
  background-color: var(--surface-defualt);
  transition: 0.4s;
  border-radius: 50%;
}

input:not(:checked) + .slider:before {
  background-color: var(--surface-default);
}

input:checked + .slider {
  background-color: var(--primary);
}

input:checked + .slider:before {
  transform: translateX(15px);
  background-color: var(--surface-default);
}

.slider.round {
  border-radius: 1rem;
}
</style>
